<template>
  <multiselect
    v-model="input"
    :placeholder="placeholder"
    :selectLabel="selectLabel"
    :deselectLabel="deselectLabel"
    :preserveSearch="isResetAfter"
    :options="options"
    :disabled="isDisabled"
    :allowEmpty="false"
    :custom-label="customlabel"
    :show-labels="false"
    :class="{ 'is-invalid': isError ? 1 : 0 }"
  >
    <span slot="noOptions">ไม่พบข้อมูล</span>
    <span slot="noResult">ไม่พบข้อมูลที่ค้นหา</span>
    <a
      slot="caret"
      v-if="isDisabled === false"
      @click="onGetAttributeSetsSelector()"
      class="btn reset-select"
    >
      <i class="ml-3 bx bx-reset" /> Reset
    </a>
  </multiselect>
</template>

<script>
// import ilbs
import Multiselect from 'vue-multiselect'
import attributesetsService from '@/helpers/service/attributesets-service'
import { StatusEnum } from '@/enum/status.enum.js'

export default {
  name: 'AttributesetSelectorComponent',
  components: {
    Multiselect,
  },
  props: {
    value: {
      type: Object,
      default: () => {
        return this.input
      },
    },
    isError: {
      type: Boolean,
      default: false,
    },
    preserveSearch: {
      type: Boolean,
      default: false,
    },
    placeholder: {
      type: String,
      default: 'ระบุข้อมูลเพื่อค้นหา',
    },
    selectLabel: {
      type: String,
      default: 'เลือก',
    },
    isDisabled: {
      type: Boolean,
      default: false,
    },
    deselectLabel: {
      type: String,
      default: '',
    },
    noResult: {
      type: String,
      default: 'ไม่พบข้อมูลที่ค้นหา',
    },
    hybridCategoryId: {
      type: String,
      default: () => {
        return ''
      },
    },
  },
  created() {
    this.onGetAttributeSetsSelector()
  },
  async mounted() {
    this.input = ''
  },
  data() {
    return {
      options: [],
      input: {
        id: '',
        display_name: { en: '', th: '' },
        attributes: [],
      },
      isInternalSearch: false,
      isResetAfter: false,
    }
  },
  watch: {
    value: function(val) {
      if (val !== null && val !== undefined && val !== '') {
        this.input = val
        // this.input = this.options.find(f => f.id === val.id)
        // for (let i = 0; i < this.input.attributes.length; i++) {
        //   this.input.attributes[i].value = val.attributes.find(
        //     f => f.id === this.input.attributes[i].id
        //   ).value
        // }
      }
    },
    input: function(val) {
      if (val !== null && val !== undefined && val !== '') {
        this.$emit('input', val)
      }
    },
    preserveSearch: function(val) {
      if (val) {
        this.onReset()
      }
    },
    hybridCategoryId: {
      handler(val) {
        this.onGetAttributeSetsSelector()
      },
      deep: true,
    },
  },
  methods: {
    customlabel({ display_name }) {
      return display_name !== null &&
        display_name !== undefined &&
        ((display_name && display_name.th !== '') ||
          (display_name && display_name.en !== ''))
        ? `${display_name.th}  :  ${display_name.en}`
        : ''
    },
    onReset() {
      this.options = []
      this.isResetAfter = true
    },
    genHexString(len) {
      const hex = '0123456789abcdef'
      let output = ''
      for (let i = 0; i < len; ++i) {
        output += hex.charAt(Math.floor(Math.random() * hex.length))
      }
      return output
    },
    async onGetAttributeSetsSelector() {
      let params = new URLSearchParams()
      params.append('pageSize', 99999)
      params.append('sort', 'display_name.en display_name.th')
      params.append('status', StatusEnum.ACTIVE)
      params.append('isGetIncludeAttributes', true)
      if (this.hybridCategoryId !== '') {
        params.append('hybridCategoryId', this.hybridCategoryId)
      }
      let result = await attributesetsService.getAttributeSetsMasterListAsync(
        params
      )
      if (result.status === 200) {
        let attributsetItems = []
        result.data.items.forEach((element, index) => {
          let attributes = []
          if (element.attributes && element.attributes.length > 0) {
            element.attributes.forEach((element2, index2) => {
              const attributeHead = {
                sequence: element2.sequence,
                type: element2.type,
                id: element2.id,
                mdc_code: element2.mdc_code,
                display_name: element2.display_name,
                is_required_value: element2.is_required_value,
              }
              const defaultData = element2.data_values.filter(
                it => it.is_default === true
              )
              let attribute = [{ ...attributeHead, value: { en: '', th: '' } }]
              if (defaultData && defaultData.length > 0) {
                attribute = defaultData.map(it => ({
                  ...attributeHead,
                  value: it.value,
                }))
              }
              attributes = [...attributes, ...attribute]
            })
          } else {
            attributes = [
              {
                sequence: 1,
                type: '',
                id: `${this.genHexString(24)}`,
                mdc_code: '',
                display_name: { en: '', th: '' },
                value: { en: '', th: '' },
                is_required_value: true,
              },
            ]
          }

          attributsetItems[index] = {
            id: element.id,
            display_name: {
              th: element.display_name ? element.display_name.th : '',
              en: element.display_name ? element.display_name.en : '',
            },
            attributes: attributes,
          }
        })
        this.options = attributsetItems
        // const attributsetItem = attributsetItems.find(
        //   it => it.id === '62b535c4501f927ccac579ca'
        // )
        // console.log(attributsetItem)
      } else {
        if (result.response.data.message) {
          console.log(result.response.data.message)
        }
      }
    },
    setDefaultValue(dataValues) {
      let result = { en: '', th: '' }
      const defaultData = dataValues.find(it => it.is_default === true)
      if (defaultData) {
        result = { en: defaultData.value.en, th: defaultData.value.th }
      }
      return result
    },
  },
}
</script>
